import { first } from 'rxjs';
import { NgForOf, NgIf, NgOptimizedImage } from '@angular/common';
import { Params, Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatOptionModule, MatRippleModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { NotificationComponent } from '@modules/notification-queue/abstract/notification.component';
import { NotificationQueueHttpService } from '@modules/notification-queue/services/notification-queue-http.service';
import { InternalTripNotificationSignalRInterface } from '@interfaces/singnal-r/internal-trip-notification-signal-r.interface';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { snoozeTimeRange } from '@modules/notification-queue/config';
import { FormsModule } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-internal-trip-notification',
  standalone: true,
  templateUrl: './internal-trip-notification.component.html',
  styleUrls: ['./internal-trip-notification.component.scss'],
  imports: [
    MatButtonModule,
    MatIconModule,
    MatRippleModule,
    NgIf,
    MatFormFieldModule,
    MatOptionModule,
    MatSelectModule,
    NgForOf,
    FormsModule,
    NgOptimizedImage,
  ],
  providers: [NotificationQueueHttpService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InternalTripNotificationComponent extends NotificationComponent {
  @Input() override notification: InternalTripNotificationSignalRInterface | null = null;

  snoozeTimeRange = snoozeTimeRange;
  snoozeTime = snoozeTimeRange[0].value;
  showSnoozeDropDown = false;

  constructor(
    router: Router,
    private readonly notificationQueueHttpService: NotificationQueueHttpService,
    private readonly toastrService: ToastrService,
  ) {
    super(router);
  }

  /**
   * Navigates to the service-request list page with specified query param
   */
  override async onViewServiceRequest(): Promise<void> {
    const queryParams: Params = { tripId: this.notification.trip };

    return super.onViewServiceRequest(null, this.notification.notificationId, '/service-request', queryParams);
  }

  /**
   * Send API call to dismiss internal trip notification and close the notification window
   */
  override closeNotification(): void {
    const notificationId = this.notification.notificationId;

    this.notificationQueueHttpService.dismissNotification(notificationId).pipe(first()).subscribe();

    super.closeNotification(notificationId);
  }

  onShowDropDown(): void {
    this.showSnoozeDropDown = !this.showSnoozeDropDown;
  }

  /**
   * Send API call to snooze internal trip notification and close the notification window
   */
  onSnoozeTimeChange(minutes: number): void {
    const notificationId = this.notification.notificationId;
    this.notificationQueueHttpService
      .snoozeNotification(notificationId, minutes)
      .pipe(first())
      .subscribe(() => {
        this.toastrService.success(`Snoozed for ${minutes} minutes`, 'Success', { timeOut: 2000, positionClass: 'toast-top-center' });
      });

    super.closeNotification(notificationId);
  }
}
